import React from 'react';
import {makeStyles, Container, Typography, IconButton, Checkbox, Hidden, Tabs, Tab, AppBar} from '@material-ui/core';
import MUIDataTable from "mui-datatables";
import AssignmentIcon from '@material-ui/icons/Assignment';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import {MuiThemeProvider} from '@material-ui/core/styles';
import TabPanel, {a11yProps} from "../UIComponent/TabPanel";
import ApprovalHistory from "./ApprovalHistory";
import CircularProgress from '@material-ui/core/CircularProgress';
import customAxios from "../../components/API/customAxios";
import {FormattedMessage, useIntl} from 'react-intl';
import {setReqApprovalColumns, setReqApprovalOptions} from "./component/TableSetting";
import {tableStyle, getMuiTheme, pxToRem} from "../UIComponent/CommonStyle"
import {isBrowser} from "react-device-detect";
import Grid from "@material-ui/core/Grid";
import {getCompLeaveApproves} from "./api/ApprovalAPI";
import ConfirmBox from '../UIComponent/ConfirmBox';
import Approve from './component/Approve';
import { CompLeaveApprovalCollection } from '../Function/CompLeaveApproval';
import { setLocalStorageSettings } from '../Function/globalFunction';
import { useHistory } from 'react-router-dom';

let isApprove = '';

const useStyles = makeStyles((theme) => ({
    ...tableStyle(theme),
}));

export default function CompLeaveReqsApproval({routing, routingId, isHRAdminRole, tabIndex, setNumberOfPendingOTs}) {
    const classes = useStyles();
    const intl = useIntl();
    const history = useHistory();
    const [showSelectBox, setShowSelectBox] = React.useState('multiple');
    const [data, setData] = React.useState([]);
    const [showId, setShowId] = React.useState();
    const [selectedRowsData, setSelectedRowsData] = React.useState({
        selectedRows: '',
        displayData: '',
    });
    const [showCompetent, setShowCompetent] = React.useState(false);
    const [showStaffNo, setShowStaffNo] = React.useState(false);
    const [selectItem, setSelectItem] = React.useState([]);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [open, setOpen] = React.useState(false);
    const [confirmOpen, setConfirmOpen] = React.useState(false);
    const [checked, setChecked] = React.useState(false);

    const [tabValue, setTabValue] = React.useState(0);

    const tab1Label = intl.formatMessage({id: 'comp_leave.pending'});
    const tab2Label = intl.formatMessage({id: 'comp_leave.history'});

    React.useEffect(() => {
        if (routing !== '') {
            setShowId(routingId)
            setOpen(routing);
        }
    }, [routing, routingId]);

    React.useEffect(() => {
        if (isHRAdminRole) {
            setShowSelectBox('none');
            setShowStaffNo(true);
        }
    }, [isHRAdminRole]);

    React.useEffect(() => {
        async function fetchData() {
            try {
                const response = await getCompLeaveApproves();
                if (response.status === 200) {
                    setData(CompLeaveApprovalCollection(response.data, intl));
                    if (typeof setNumberOfPendingOTs === 'function') {
                        setNumberOfPendingOTs(response.data.length);
                    }
                    setShowCompetent(true);
                }
            } catch (error) {
                console.error("Failed to fetch data:", error);
                setShowCompetent(false);
            }
        }
    
        fetchData();
    }, []);

    React.useEffect(() => {
        setRowsPerPage(data.length);
        const params = new URLSearchParams(location.search);

        const processingApplicationId = params.get('processingApplicationId');
        if (processingApplicationId && data.length > 0) {
            const index = data.findIndex(row => row.id === processingApplicationId);

            if (index !== -1) {
                setSelectItem([index]);
            }
        }
    }, [location, data]);

    const handleOpen = (id) => {
        setShowId(id)
        setOpen(true);
    };
    const handleClose = () => {
        setLocalStorageSettings({
            'selectedIndex': 5,
            'isMyRequestOpen': 'false',
            'isApplicationOpen': 'false',
            'isLeaveApprovalOpen': 'true',
            'isHRAdminOpen': 'false'
        });
        history.push('/leave_approval?tabIndex=1');
        setOpen(false);
    };

    const handleConfirmOpen = (selectIndex, selectData, action) => {
        isApprove = action;
        setConfirmOpen(true);
        setSelectedRowsData({
            selectedRows: selectIndex,
            displayData: selectData
        })
    };
    const handleConfirmClose = () => {
        setConfirmOpen(false);
    };

    const handleChange = (event) => {
        setChecked(event.target.checked);
        if (event.target.checked === true) {
            setSelectItem([...Array(data.length).keys()])
        } else {
            setSelectItem([])
        }
    }

    let customToolbar = () => {
        return (
            <Hidden mdUp>
                {/* { showSelectBox ? */}
                <IconButton style={{order: -1, height: pxToRem(45)}}>
                    <Checkbox
                        style={{color: '#FFF'}}
                        checked={checked}
                        onChange={handleChange}
                        inputProps={{'aria-label': 'primary checkbox'}}
                    />
                </IconButton>
                {/* : null */}
            </Hidden>
        );
    }
    let customBodyRender = (value, tableMeta, updateValue) => {
        return (
            <AssignmentIcon onClick={() => handleOpen(tableMeta.rowData[0])}
                            className={classes.muiDataTableIcon}/>
        );
    }
    let customToolbarSelect = (selectedRows, displayData, setSelectedRows) => (
        <React.Fragment>
            <div className={classes.customToolbarSelect}>
                <IconButton onClick={() => handleConfirmOpen(selectedRows.data, displayData, 'approve')}>
                    <CheckCircleIcon className={classes.deleteIcon} style={{color: '#FFF'}}/>
                    <Typography className={classes.customToolbarSelectText}
                                style={{color: '#FFF'}}>{intl.formatMessage({id: 'comp_leave.approve'})}</Typography>
                </IconButton>
                <IconButton onClick={() => handleConfirmOpen(selectedRows.data, displayData, 'reject')}>
                    <CancelIcon className={classes.deleteIcon} style={{color: '#FFF'}}/>
                    <Typography className={classes.customToolbarSelectText}
                                style={{color: '#FFF'}}>{intl.formatMessage({id: 'comp_leave.reject'})}</Typography>
                </IconButton>
                <Hidden mdUp>
                    <IconButton>
                        <Checkbox
                            style={{color: '#FFF'}}
                            checked={checked}
                            onChange={handleChange}
                            inputProps={{'aria-label': 'primary checkbox'}}
                        />
                    </IconButton>
                </Hidden>
            </div>
        </React.Fragment>
    );
    let columns = setReqApprovalColumns(customBodyRender, showStaffNo, intl);
    const options = setReqApprovalOptions(selectItem, showSelectBox, customToolbar, handleOpen, customToolbarSelect, intl, rowsPerPage);

    if (isBrowser === false) {
        columns = columns.filter(item => item.name !== 'approve')
    }

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    return (
        <main className={classes.content}>
            <Container maxWidth={false} className={classes.container}>
                {showCompetent ?
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Typography component="h1" variant="h5" align="left" style={{fontWeight: 600}}>
                                {intl.formatMessage({ id: 'navigation.pending_approval' }) + ' - ' + intl.formatMessage({ id: 'navigation.ot_compensation' })}
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <MuiThemeProvider theme={getMuiTheme()}>
                                <MUIDataTable
                                    title={intl.formatMessage({id: 'table.employee_list'})}
                                    data={data}
                                    columns={columns}
                                    options={options}
                                />
                            </MuiThemeProvider>
                        </Grid>
                    </Grid>
                    :
                    <div className={classes.circularProgress}>
                        <CircularProgress/>
                    </div>
                }
            </Container>
            {open && (
               <Approve 
                    approveMode={window.global.singleApprove} 
                    handleClose={handleClose} 
                    open={open}
                    showId={showId}
                    tabIndex={tabIndex}
                />
            )}
            {confirmOpen && (
                <ConfirmBox 
                    approveMode={window.global.multipleApprove}
                    leaveMode={window.global.compLeaveRequest}
                    handleClose={handleConfirmClose}
                    open={confirmOpen}
                    selectedRows={selectedRowsData.selectedRows} 
                    displayData={selectedRowsData.displayData}
                    isApprove={isApprove}
                    tabIndex={tabIndex}
                />
            )}
        </main>
    );
}
